import {
  SkeletonText,
  SkeletonCircular,
  token,
} from '@ferreri/prever-component-lib';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const SkeletonCategoriesListItem = () => {
  return (
    <FlexColumn>
      <GapSkeleton>
        <SkeletonCircular size={48} />
        <SkeletonText lines={2} width="auto" textSize="sm" />
      </GapSkeleton>
    </FlexColumn>
  );
};

const gap = css`
  gap: ${token.spacing.spacingXSmall};
`;

const FlexColumn = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  max-width: 80px;
  min-width: 80px;
  padding: ${token.spacing.spacingXxSmall} 0;
  text-align: center;
  flex-direction: column;
  ${gap};
`;

const GapSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  ${gap};
`;
